import React from "react";

import Placeholder, { Rect } from "components/Placeholder";

const DesktopSearchAdPlaceholder: React.FC = () => {
  return (
    <div className="flex justify-center pb-lg">
      <Placeholder width="728" height="90">
        <Rect width="728" height="90" />
      </Placeholder>
    </div>
  );
};

export default DesktopSearchAdPlaceholder;
